import { render } from "./Favourite.vue?vue&type=template&id=fad638ac"
import script from "./Favourite.vue?vue&type=script&lang=js"
export * from "./Favourite.vue?vue&type=script&lang=js"

import "./Favourite.vue?vue&type=style&index=0&id=fad638ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__